import { useMemo } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal, Select } from "components";
import { Button, Label } from "expano-components";

import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";

const SelectField = (props) => <Select {...props} />;

const AddPlatform = ({
  handleClose,
  handleSubmit,
  change,
  pristine,
  shop_id,
  platform_ids,
  refetch,
}) => {
  const { data: platforms } = useGet({
    query: ["platforms", platform_ids],
    context: "list",
    path: "/platforms",
    search: {
      per_page: 1000,
      "q[id_not_in]": platform_ids,
    },
  });

  const { is_creating, create } = useCreate({
    path: "/channels",
    onSuccess: () => [refetch(), handleClose()],
  });

  const onSubmit = async ({ platform_id }) =>
    create({
      shop_id,
      platform_id,
    });

  const platforms_options = useMemo(() => {
    if (!platforms?.length) {
      return [];
    }

    return platforms.map(({ id, name, label_color, label_text }) => ({
      label: (
        <>
          <Label text={label_text} type="bordered" color={label_color} />
          <span>{name}</span>
        </>
      ),
      value: id,
    }));
  }, [platforms]);

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Dodaj platformę",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={pristine || is_creating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <p className="m-b-10">
        Wybierz platformę na której chcesz prowadzić sprzedaż.
      </p>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Field
          label="Platforma"
          name="platform_id"
          component={SelectField}
          options={platforms_options}
          handleChange={(value) => change("platform_id", value)}
        />
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "create-channel-by-platform",
  initialValues: { platform_id: null },
})(AddPlatform);
